'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
const validateDate = value => {
  const [day, month, year] = value.split('/');
  const dayNumber = parseInt(day, 10);
  const monthNumber = parseInt(month, 10);
  const yearNumber = parseInt(year, 10);
  let newValue = value;
  if ((day === null || day === void 0 ? void 0 : day[0]) > '3' && !(day !== null && day !== void 0 && day[1])) {
    newValue = "0".concat(day[0]);
  }
  if (dayNumber > 31 || dayNumber === 0) {
    return day[0];
  }
  if ((month === null || month === void 0 ? void 0 : month[0]) > '1' && !(month !== null && month !== void 0 && month[1])) {
    newValue = "".concat(day, "/0").concat(month[0]);
  }
  if (monthNumber > 12 || monthNumber === 0) {
    return "".concat(day, "/").concat((month === null || month === void 0 ? void 0 : month[0]) === '1' || (month === null || month === void 0 ? void 0 : month[0]) === '0' ? month === null || month === void 0 ? void 0 : month[0] : '');
  }
  const daysInMonth = [31, Number(year) % 4 === 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (monthNumber && Number(String(monthNumber)[0]) !== 0 && dayNumber > daysInMonth[monthNumber - 1]) {
    return "".concat(day, "/").concat(month[0]);
  }
  if (yearNumber === 0) return "".concat(day, "/").concat(month);
  if (yearNumber) {
    const firstDigit = year === null || year === void 0 ? void 0 : year[0];
    const secondDigit = year === null || year === void 0 ? void 0 : year[1];
    const thirdDigit = year === null || year === void 0 ? void 0 : year[2];
    const fourthDigit = year === null || year === void 0 ? void 0 : year[3];
    if (firstDigit && firstDigit !== '1' && firstDigit !== '2') {
      return "".concat(day, "/").concat(month, "/");
    }
    if (secondDigit && !(firstDigit === '1' && secondDigit === '9' || firstDigit === '2' && (secondDigit === '1' || secondDigit === '0'))) {
      return "".concat(day, "/").concat(month, "/").concat(firstDigit);
    }
    if (thirdDigit && !(secondDigit === '9' || secondDigit === '0' || secondDigit === '1' && thirdDigit === '0')) {
      return "".concat(day, "/").concat(month, "/").concat(firstDigit).concat(secondDigit);
    }
    if (fourthDigit && !(secondDigit === '9' || secondDigit === '0' || secondDigit === '1' && fourthDigit === '0')) {
      return "".concat(day, "/").concat(month, "/").concat(firstDigit).concat(secondDigit).concat(thirdDigit);
    }
  }
  return newValue;
};
const validateDateTime = value => {
  const [dateStr, timeStr] = value.split(' ');
  const [hour, minute, seconds] = timeStr ? timeStr.split(':') : [];
  const dateValue = validateDate(dateStr);
  const newValue = timeStr ? "".concat(dateValue, " ").concat(timeStr) : dateValue;
  if (parseInt(hour === null || hour === void 0 ? void 0 : hour[0], 10) > 2) return dateValue;
  const hourNumber = parseInt(hour, 10);
  if (hourNumber > 23) return "".concat(dateValue, " ").concat(hour[0]);
  if (parseInt(minute === null || minute === void 0 ? void 0 : minute[0], 10) > 5) return "".concat(dateValue, " ").concat(hour);
  if (parseInt(seconds === null || seconds === void 0 ? void 0 : seconds[0], 10) > 5) return "".concat(dateValue, " ").concat(hour, ":").concat(minute);
  return newValue;
};
var date = {
  mask: 'DD/DD/DDDD',
  tokens: {
    D: {
      pattern: /\d/
    }
  },
  eager: true,
  preProcess: value => value.replace(/[^\d/:]/g, ''),
  postProcess: value => validateDate(value)
};
var money = {
  mask: 'N,DD',
  tokens: {
    N: {
      pattern: /\d/,
      multiple: true
    },
    D: {
      pattern: /\d/,
      optional: true
    }
  },
  preProcess: val => val.replace(/\./g, ''),
  postProcess: val => {
    if (!val || val === ',') return '';
    const sub = 3 - (val.includes(',') ? val.length - val.indexOf(',') : 0);
    return Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(Number(val.replace(',', '.'))).replace('R$', '').replace(/\s/g, '').slice(0, sub ? -sub : undefined);
  }
};
var phone = {
  mask: '(ZZ) DDD-DDDD',
  eager: true,
  tokens: {
    Z: {
      pattern: /[1-9]/
    },
    D: {
      pattern: /\d/
    }
  }
};
var mobile = {
  mask: '(ZZ) DDDDD-DDDD',
  eager: true,
  tokens: {
    Z: {
      pattern: /[1-9]/
    },
    D: {
      pattern: /\d/
    }
  }
};
var zipcode = {
  mask: 'DDDDD-DDD',
  eager: true,
  tokens: {
    A: {
      pattern: /[a-z]/
    },
    D: {
      pattern: /\d/
    }
  }
};
var cnpj = {
  mask: 'DD.DDD.DDD/DDDD-DD',
  eager: true,
  tokens: {
    D: {
      pattern: /\d/
    }
  }
};
var cpf = {
  mask: 'DDD.DDD.DDD-DD',
  eager: true,
  tokens: {
    D: {
      pattern: /\d/
    }
  }
};
var rg = {
  mask: 'DD.DDD.DDD-D',
  eager: true,
  tokens: {
    D: {
      pattern: /\d/
    }
  }
};
var datetime = {
  mask: 'DD/DD/DDDD DD:DD:DD',
  tokens: {
    D: {
      pattern: /\d/
    }
  },
  eager: true,
  preProcess: value => value.replace(/[^\d/:]/g, ''),
  postProcess: value => validateDateTime(value)
};
exports.CNPJ = cnpj;
exports.CPF = cpf;
exports.MOBILE = mobile;
exports.PHONE = phone;
exports.RG = rg;
exports.ZIPCODE = zipcode;
exports.date = date;
exports.datetime = datetime;
exports.money = money;
